import { MODULE_LINK_TYPE } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/course/${moduleId}/${seriesId}/edit`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/new/ui/admin/course/${moduleId}/${seriesId}/track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/course/learners?gameType=course&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
